import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-school-book-enquiry-form',
  templateUrl: './school-book-enquiry-form.component.html',
  styleUrls: ['./school-book-enquiry-form.component.css']
})
export class SchoolBookEnquiryFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
